var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplayIcon = function SvgReplayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.75 10.566H22.8a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h4.7v-4.7c0-.683.567-1.25 1.25-1.25S30 2.683 30 3.366v5.95c0 .683-.567 1.25-1.25 1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.134 30.267C6.784 30.267 0 23.484 0 15.134S6.783 0 15.134 0c5.75 0 10.916 3.183 13.517 8.317A1.25 1.25 0 0 1 28.1 10a1.25 1.25 0 0 1-1.684-.55C24.25 5.167 19.934 2.5 15.134 2.5 8.167 2.5 2.5 8.167 2.5 15.134c0 6.966 5.667 12.633 12.634 12.633 4.516 0 8.716-2.433 10.966-6.35.35-.6 1.117-.8 1.7-.467.6.35.8 1.1.467 1.7a15.19 15.19 0 0 1-13.133 7.6z"
  })));
};
export default SvgReplayIcon;